import { InjectionToken } from '@angular/core';

export interface AumicoIntegrationsConfig {
    apiGateway: string;
}

export const AumicoIntegrationsConfigService = new InjectionToken<AumicoIntegrationsConfig>(
    'AumicoIntegrationsConfigService',
);
